import React from 'react';
import { PredefinedPhrase } from '../../PredefinedPhrasesSetup/PredefinedPhrasesList';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import PredefinedPhraseSelection from './PredefinedPhraseSelection';
import { PhraseType } from '../../../../../graphql/graphql';
import { Size } from '../../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	onSelect: (item: PredefinedPhrase) => void;
	type: PhraseType;
}

const PredefinedPhraseSelectionModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.predefinedPhraseSelection.modalTitle'
			contentStyle={{ padding: 0 }}
			contentScroll={false}
			size={Size.FULLSCREEN}>
			<PredefinedPhraseSelection type={props.type} onSelect={props.onSelect} />
		</BaseModal>
	);
};

export default PredefinedPhraseSelectionModal;
